var kef_table_comparison = {
  init: () => {
    $('.kef-table-comparison').each(function(i) {
      var datas = $(this).data(),
          enable_accordion = datas['accordion'] || false;

      if (enable_accordion) {
        $(this).addClass(`kef-table-comparison-accordion`);
      }

      var W = 100,
          W_measure = '%',
          l = $('thead tr th', this).length;
      if (l <= 2) {
        W = 100;
        W_measure = '%';
      }
      $(this).addClass(`kef-table-comparison-${l}`);
      $(this).get(0).style = `
        --kef-table-comparison-width-${i+1}: ${W}${W_measure};
        --kef-table-comparison-cell-total-${i+1}: ${l};
      `;

      $('p', this).each(function() {
        if ($('img', this).length > 0) {
          $(this).addClass('img');
        }
      });

      $('.btn', this).each(function() {
        $(this).addClass('btn-secondary btn-sm');
      });

      // get background color
      var color = '';
      var bg_color = '';
      var el_parent = $(this).get(0);
      do {
        el_parent = el_parent.parentElement;
        bg_color = getComputedStyle(el_parent.parentElement).backgroundColor;
        if (bg_color != 'rgba(0, 0, 0, 0)') {
          color = `background-color: ${bg_color};`;
        }
      } while(color == '' && el_parent.nodeName != 'BODY');
      if (color == '') {
        color = `background-color: #fff;`;
      }

      var html = ``;
      html += `<div class="table table-thead">`;
      $('thead', this).each(function() {
        html += `<div class="thead ${$(this).attr('class') || ''}" style="width: var(--kef-table-comparison-width-${i+1}); ${color} ${$(this).attr('style') ?? ''}">`;
        $('tr', this).each(function() {
          html += `<div class="tr ${$(this).attr('class') || ''}">`;
          $('th', this).each(function() {
            html += `<div class="th ${$(this).attr('class') || ''}">${$(this).html()}</div>`;
          });
          html += `</div>`;
        });
        html += `</div>`;
      });
      html += `</div>`;

      html += `<div class="table table-tbody">`;
      $('tbody ', this).each(function() {
        html += `<div class="tbody ${$(this).attr('class') || ''}" style="width: var(--kef-table-comparison-width-${i+1}); ${$(this).attr('style') ?? ''}">`;
        $('tr', this).each(function() {
          var label = $(this).attr('data-title');
          label_arr = label.split(' ');
          $.each(label_arr, function(i, val) {
            if (val.toLowerCase().indexOf('-3db') >= 0) {
              label_arr[i] = `<span class="smallcase">${val}</span>`;
            }
          });
          label = label_arr.join(' ');
          html += `<div class="kef-table-comparison-label">${label}</div>`;
          
          html += `<div class="tr ${$(this).attr('class') || ''}">`;
          $('td', this).each(function() {
            html += `<div class="td ${$(this).attr('class') || ''}">${$(this).html()}</div>`;
          });
          html += `</div>`;
        });
        html += `</div>`;
      });
      html += `</div>`;

      $(this).html(html);
    });

    $(document).trigger({
      type: 'init_kef_table_comparison'
    });
  },
  initEvent: () => {
    $('body').on('scroll wheel', '.kef-table-comparison .table', function(e) {
      var l = $(this).scrollLeft();
      $(this).siblings('.table').scrollLeft(l);
    });

    $('body').on('click', '.kef-table-comparison-accordion .kef-table-comparison-label', function(e) {
      $(this).toggleClass('active');
    });
  },
}
$(function() {
  kef_table_comparison.init();
  kef_table_comparison.initEvent();
});